export class QuestionCategory {
  constructor({ id, name, order = 1, status = NaN }) {
    this.id = id;
    this.name = name;
    this.order = order;
    this.status = status;
  }
}
